import React from "react";
import "./SettingsNewFooter.css";

function Footer() {
  return <div className="settingsnewfooter"></div>;
}

export default Footer;
